import script from "./DocumentLoadingPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentLoadingPanel.vue?vue&type=script&setup=true&lang=js"

import "./DocumentLoadingPanel.vue?vue&type=style&index=0&id=1f4f16f4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f4f16f4"]])

export default __exports__